import { type FirebaseApp, type FirebaseOptions, initializeApp } from "firebase/app"
import { type App, InjectionKey } from "vue"

declare module "vue" {
    interface ComponentCustomProperties {
        $firebase: FirebaseApp
    }
}

export const firebaseKey = Symbol() as InjectionKey<FirebaseApp>
export const firebase = {
    install: (app: App, options: FirebaseOptions) => {
        const firebaseApp = initializeApp(options)

        app.provide(firebaseKey, firebaseApp)
        app.config.globalProperties.$firebase = firebaseApp
    }
}

export function isDemo(firebase: FirebaseApp) {
    return firebase.options.projectId!.includes("demo")
}
